// @flow
import React, { Fragment, Component } from 'react';
import type { Status } from 'types/Status';
import type { CentenaireDocumentType } from 'types/Centenaire';

import {
  STATUS_SUCCESS,
} from 'constants/statusConstants';

import CentenaireCard from 'containers/centenaire/CentenaireCardContainer';

export type DispatchProps = {
  fetchCentenaireDocuments: (data: Object) => void
};
export type StateProps = {
  statusDocuments: Status,
  documents: Array<CentenaireDocumentType>,
};

type Props = {
  actuel: string,
  queryCentenaire: string,
} & StateProps & DispatchProps;

type State = {
  documents: Array<CentenaireDocumentType>
};

class CentenaireAssociesContainer extends Component<Props, State> {
  props: Props;
  state: State = {
    documents: []
  };

  componentDidMount() {
    if (this.props.queryCentenaire) {
      this.props.fetchCentenaireDocuments({
        queryCentenaire: this.props.queryCentenaire,
        length:5
      });
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevProps.documents.length !== this.state.documents.length) {
      this.setState({documents: this.props.documents});
    }
  }

  renderDocuments = () => {
    const { documents, actuel } = this.props;
    let visibles = 0;
    return documents.map<any>((document, index) => {
      if (document.id === actuel || visibles === 4) {
        return null;
      }
      visibles++;
      return (
        <div className={(visibles > 2 ? 'hide-minScreen ' : '') + 'mb-2 col col-md-6 col-lg-3'} key={`centenaire`+index}>
          <CentenaireCard {...document} queryCentenaire={this.props.queryCentenaire} />    
        </div>
      );
    });
  }

  render() {
    const {
      actuel,
      documents,
      statusDocuments,
    } = this.props;
    const documentInside = documents.filter((document) => {
      return document.id === actuel;
    });
    return (
      <Fragment>
        {statusDocuments === STATUS_SUCCESS && documents.length > ((documentInside.length > 0) ? 1 : 0) && 
        <div className="section">
          <h2 className="mb-3 ft-h3 ft-white">Souvenirs associés</h2>
          <div className="row">
            {this.renderDocuments()}
          </div>
        </div>
        }
      </Fragment>
    );
  }
}

export default CentenaireAssociesContainer;
